import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { generateId } from '../../utils/helpers';
import DateInput from '../../components/common/DateInput';

const emptyForm = {
  studentName: '',
  fatherName: '',
  motherName: '',
  phone: '',
  location: '',
  classInterested: '',
  enquiryDate: new Date().toISOString().split('T')[0],
  status: 'new',
  notes: '',
};

const inputCls = 'w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300';
const classList = ['Nursery','LKG','UKG','Class 1','Class 2','Class 3','Class 4','Class 5','Class 6','Class 7','Class 8','Class 9','Class 10'];

function AdmissionEnquiry() {
  const { setEnquiries } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ ...emptyForm });

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setEnquiries(prev => [...prev, { ...form, id: generateId('ENQ') }]);
    navigate('/admission/enquiries');
  };

  return (
    <div className="max-w-xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">New Enquiry</h1>
        <p className="text-gray-500 text-sm mt-0.5">Record a new admission enquiry</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 space-y-4">

        <div>
          <label className="block text-sm font-medium mb-1">Student Name <span className="text-red-500">*</span></label>
          <input required value={form.studentName} onChange={e => set('studentName', e.target.value)} className={inputCls} placeholder="Full name of student" />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Father's Name</label>
            <input value={form.fatherName} onChange={e => set('fatherName', e.target.value)} className={inputCls} placeholder="Father's full name" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Mother's Name</label>
            <input value={form.motherName} onChange={e => set('motherName', e.target.value)} className={inputCls} placeholder="Mother's full name" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Phone <span className="text-red-500">*</span></label>
            <input required type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} className={inputCls} placeholder="e.g. 9876543210" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Location</label>
            <input value={form.location} onChange={e => set('location', e.target.value)} className={inputCls} placeholder="Area / City" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Class Interested</label>
            <select value={form.classInterested} onChange={e => set('classInterested', e.target.value)} className={inputCls}>
              <option value="">Select Class</option>
              {classList.map(c => <option key={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Enquiry Date</label>
            <DateInput value={form.enquiryDate} onChange={e => set('enquiryDate', e.target.value)} className={inputCls} />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Notes</label>
          <textarea value={form.notes} onChange={e => set('notes', e.target.value)} rows={3} className={inputCls} placeholder="Any additional notes..." />
        </div>

        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={() => navigate('/admission/enquiries')} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50">
            Cancel
          </button>
          <button type="submit" className="px-5 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700">
            Save Enquiry
          </button>
        </div>

      </form>
    </div>
  );
}

export default AdmissionEnquiry;
